export default {
  methods: {
    useInstallationName(str = '', installationName) {
      return str.replace(/Convergence/g, installationName);
    },
  },
};
